import { useContext } from "react";
import { Link, NavLink } from "react-router-dom";

import { Context } from "../../Context/Context";


// import styles from "../../Styles/Common/Sidenav.module.css";


const Sidenav = ({ sidenav, setSidenav }) => {

    const { json } = useContext(Context);
    const headerContent = json.header;

    return (
        <div className={sidenav ? "modal-sheet sidenav active" : "modal-sheet sidenav"}>
            <div className="modal-sheet-content rightSheet-content h-100 sidenav-content">
                <div className="modal-sheet-body">
                    <div className="text-center mt-3 mb-5">
                        <a className="sidenav-logo" href="/">
                            <img src="/imgs/wisercam logo.svg" alt="..." />
                        </a>
                    </div>
                    <div className="accordion" id="accordionPanelsStayOpenExample">
                        {/* {headerContent.navLink.map((item, index) =>
                            item.dropdown ?
                                <div
                                    key={`sidenavItem_${index}`}
                                    className="accordion-item main-accordion-item sidenav-link"
                                >
                                    <a href={item.link} className="accordion-header collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target={`#panelsStayOpen-collapse-${index + 1}`} aria-expanded="false"
                                        aria-controls={`panelsStayOpen-collapse-${index + 1}`}>
                                        {item.title}
                                    </a>
                                    <div id={`panelsStayOpen-collapse-${index + 1}`} className="accordion-collapse collapse">
                                        <div className="accordion-body">
                                            <ul className="store-category">
                                                {
                                                    item.dropdownContent.map((item2, index2) =>
                                                        <li
                                                            key={`sidenavItem2_${index2}`}
                                                            className="store-category-item"
                                                        >
                                                            <a target="_blank" href={item2.link}>
                                                                {item2.text}
                                                            </a>
                                                        </li>
                                                    )
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                :
                                <a
                                    key={`sidenavLink_${index}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    href={item.link}
                                    className="sidenav-link"
                                >
                                    <div className="sidenav-link-header">
                                        {item.title}
                                    </div>
                                </a>
                        )} */}
                        <Link to="/Order" className="sidenav-link">
                            <div className="sidenav-link-header">
                                {json.headerAccount.accountLink1}
                            </div>
                        </Link>
                        <Link to="/Quotes" className="sidenav-link">
                            <div className="sidenav-link-header">
                                {json.headerAccount.accountLink2}
                            </div>
                        </Link>
                        <Link to="/cart" className="sidenav-link">
                            <div className="sidenav-link-header">
                                {json.headerAccount.accountLink3}
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="modal-sheet-back" onClick={() => setSidenav(false)}>
            </div>
        </div>
    );
}

export default Sidenav;